import React from 'react';
import './LegalPage.css';
import { useTranslation } from '../hooks/useTranslation';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container-narrow">
      <h1 className="page-title">{t('privacy.title')}</h1>
      
      <div className="legal-content">
        <p className="legal-intro">
          {t('privacy.lastUpdated')} {new Date().toLocaleDateString()}
        </p>

        <section className="legal-section">
          <h2>{t('privacy.section1Title')}</h2>
          <p>
            {t('privacy.section1Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.section2Title')}</h2>
          <p>
            {t('privacy.section2Content')}
          </p>
          <ul>
            <li>{t('privacy.section2Item1')}</li>
            <li>{t('privacy.section2Item2')}</li>
            <li>{t('privacy.section2Item3')}</li>
            <li>{t('privacy.section2Item4')}</li>
            <li>{t('privacy.section2Item5')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.section3Title')}</h2>
          <p>
            {t('privacy.section3Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.section4Title')}</h2>
          <p>
            {t('privacy.section4Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.section5Title')}</h2>
          <p>
            {t('privacy.section5Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.section6Title')}</h2>
          <p>
            {t('privacy.section6Content')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
